/* eslint-disable react/prop-types */
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import { AttachReferenceArt } from '../../../../../components/AttachReferenceArt'

export const EditArtField = ({
  onChangePromptEditArt,
  onClickSendEditArtPrompt,
  disabled,
  onChangeImage,
  onChangeReferenceArt,
  selectedImageCategory,
  isUsingReferenceArt,
  isUsingPrincipalImage,
  isUsingBackgroundImage,
}) => {
  const [inputEditImageProptData, setInputEditImageProptData] = useState('')
  const [referenceArt, setReferenceArt] = useState(null);
  const [selectedImage, setSelectedImage] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    onChangePromptEditArt(inputEditImageProptData)
  }, [inputEditImageProptData])

  const customInputRef = useRef(null)
  const { t } = useTranslation()

  const handleInput = () => {
    const element = customInputRef.current;
    element.style.height = 'auto';
    element.style.overflow = 'auto';
    const content = element.scrollHeight;
    element.style.height = content + 'px';
  }

  const getChangeImageLabel = () => {
    const baseLabel = t('change_image_label') || 'Alterar imagem';

    if (!selectedImageCategory || selectedImageCategory.length === 0) {
      return { label: baseLabel, imageCategory: null };
    }

    const labelArray = selectedImageCategory.map(category => {
      if (category.categoryId !== 'Principal' && category.categoryId !== 'Background') {
        return baseLabel;
      } else {
        const categoryLabel = category.categoryId === 'Principal'
          ? ('principal')
          : ('background');
        return { label: `${baseLabel} ${categoryLabel}`, imageCategory: category.categoryId }
      }
    });

    return labelArray;
  }
  // Verifica se há imagem selecionada
  const hasSelectedImage = !!selectedImageCategory;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #D9D9D9',
        borderRadius: 20,
        padding: 30,
        gap: 10,
        maxWidth: '100%'
      }}
    >
      <label
        style={{
          fontSize: 14,
          color: '#686868',
          fontWeight: 500,
        }}
      >
        {t('new_publication_page_ia_step_fourth_edit_text')}
      </label>
      <p style={{
        fontSize: 12,
        color: '#FF8B00',
        fontWeight: 400,
        marginTop: '-2px',
      }}>{t('new_publication_page_ia_step_fourth_edit_art_description')}</p>

      {(selectedImage || referenceArt) && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            marginBottom: '0px',
          }}
        >

          {selectedImage?.map((slctImage) => (
            <div
              title={slctImage?.imageCategory}
              key={slctImage?.id}
              style={{
                position: 'relative',
                width: '115px',
                height: '115px',
                borderRadius: '6px',
                overflow: 'hidden',
                border: '2px solid #FDA335',
                background: 'white',
                boxShadow: '0px 2px 8px rgba(106, 0, 152, 0.15)',
                flexShrink: 0,
                marginBottom: '0px',
              }}
            >

              <img
                src={`data:${slctImage?.fileFormat};base64,${slctImage?.base64}`}
                alt="Preview"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (onChangeImage) {
                    const newArr = selectedImage.filter(img => img?.id !== slctImage?.id);
                    // console.log(newArr)
                    setSelectedImage(newArr);
                    onChangeImage(newArr);
                  }
                }}
                type="button"
                title="Remover imagem"
                aria-label="Remover imagem"
                style={{
                  position: 'absolute',
                  top: '4px',
                  right: '4px',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  background: 'white',
                  color: '#190027',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '14px',
                  lineHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  fontWeight: 600,
                  zIndex: 10,
                  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                }}
              >
                ×
              </button>
            </div>
          ))}
          {referenceArt && (
            <div
              title={'Arte de referência'}
              style={{
                position: 'relative',
                width: '115px',
                height: '115px',
                borderRadius: '6px',
                overflow: 'hidden',
                border: '2px solid #FF2F00',
                background: 'white',
                boxShadow: '0px 2px 8px rgba(106, 0, 152, 0.15)',
                flexShrink: 0,
                marginBottom: '0px',
              }}
            >
              <img
                src={`data:${referenceArt.type || 'image/png'};base64,${referenceArt.base64}`}
                alt="Preview"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setReferenceArt(null);
                  if (onChangeReferenceArt) {
                    onChangeReferenceArt(null);
                  }
                }}
                type="button"
                title="Remover imagem"
                aria-label="Remover imagem"
                style={{
                  position: 'absolute',
                  top: '4px',
                  right: '4px',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  background: 'white',
                  color: '#190027',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '14px',
                  lineHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  fontWeight: 600,
                  zIndex: 10,
                  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                }}
              >
                ×
              </button>
            </div>
          )}
        </div>
      )}
      <div
        className={styles.text_area_wrapper}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 20,
          width: '100%',
          maxWidth: '100%',
          marginTop: '-5px',
        }}

      >
        {/* <input  
          type="text"
          placeholder="Digite um comando para alterar o que quiser na arte... ex.'Mude a cor para.."
          disabled={disabled}
          value={inputEditImageProptData}
          id='instructions'
          className={styles.instructions}
          onChange={(e)=>setInputEditImageProptData(e.target.value)}
        /> */}

        <div
          onClick={() => customInputRef.current.focus()}
          className={styles.instructions_text}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: 10,
            flex: 1,
            minWidth: 0,
          }}
        >
          <AttachReferenceArt
            open={open}
            setOpen={setOpen}
            options={
              [
                // ...getChangeImageLabel().map((image) => ({
                //   label: image.label,
                //   onSelect: (imageData) => {
                //     const [, base64Data] = imageData.base64.split(',');   

                //     const imgFormatedObject = {
                //       base64: base64Data,
                //       imageCategory: image?.imageCategory,
                //       id: selectedImage.length + 1,
                //       fileFormat: imageData?.file?.type,
                //     }

                //     setSelectedImage((prev)=>{
                //       const newArr = [...prev, imgFormatedObject];
                //       console.log('new arr', newArr) 
                //       if (onChangeImage) {
                //         onChangeImage(newArr);
                //       }
                //       return newArr;
                //     })


                //   },
                //   disabled: !hasSelectedImage
                // })),
                {
                  label: t('attach_reference_art.change_main_image'),
                  onSelect: (imageData) => {
                    const [, base64Data] = imageData.base64.split(',');

                    const imgFormatedObject = {
                      base64: base64Data,
                      imageCategory: 'Principal',
                      id: selectedImage.length + 1,
                      fileFormat: imageData?.file?.type,
                    }

                    setSelectedImage(() => {
                      const newArr = [imgFormatedObject];
                      if (onChangeImage) {
                        onChangeImage(newArr);
                      }
                      return newArr;
                    })


                  },
                  disabled: !isUsingPrincipalImage
                },
                {
                  label: t('attach_reference_art.change_background_image'),
                  onSelect: (imageData) => {
                    const [, base64Data] = imageData.base64.split(',');

                    const imgFormatedObject = {
                      base64: base64Data,
                      imageCategory: 'Background',
                      id: selectedImage.length + 1,
                      fileFormat: imageData?.file?.type,
                    }

                    setSelectedImage((prev) => {
                      const newArr = [...prev, imgFormatedObject];
                      // console.log('new arr', newArr)
                      if (onChangeImage) {
                        onChangeImage(newArr);
                      }
                      return newArr;
                    })


                  },
                  disabled: !isUsingBackgroundImage
                },
                {
                  label: t('attach_change_reference_art_label') || 'Alterar imagem de referência',
                  onSelect: (imageData) => {
                    const [, base64Data] = imageData.base64.split(',');

                    const referenceArtFormatted = {
                      ...imageData,
                      base64: base64Data,
                    }
                    setReferenceArt(referenceArtFormatted);
                    if (onChangeReferenceArt) {
                      onChangeReferenceArt(referenceArtFormatted);
                    }
                  },
                  disabled: !isUsingReferenceArt
                }
              ]
            }
            acceptedFormats="image/*"
            maxFileSize={10 * 1024 * 1024}
            showPreview={false}
            verticalLayout={true}
            disabled={disabled}
          />
          <textarea
            type="text"
            style={{ overflow: 'hidden' }}
            placeholder={t('new_publication_page_ia_step_fourth_edit_art_input_placeholder')}
            disabled={disabled}
            id='instructions'
            onInput={handleInput}
            rows={1}
            className={styles.instructions}
            ref={customInputRef}
            value={inputEditImageProptData}
            onChange={(e) => setInputEditImageProptData(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                onClickSendEditArtPrompt(inputEditImageProptData);
              }
            }}
          />

          <button
            onClick={() => !disabled ? onClickSendEditArtPrompt(inputEditImageProptData) : null}
            disabled={disabled}
            style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: disabled ? '#cccc' : '#6A0098',
              color: disabled ? '#999' : '#fff',
              border: 'none',
              cursor: disabled ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              flexShrink: 0,
              transition: 'background 0.2s ease, transform 0.1s ease',
            }}
            onMouseEnter={(e) => {
              if (!disabled) {
                e.currentTarget.style.background = '#8b00cc';
                e.currentTarget.style.transform = 'scale(1.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (!disabled) {
                e.currentTarget.style.background = '#6A0098';
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}
            onMouseDown={(e) => {
              if (!disabled) {
                e.currentTarget.style.transform = 'scale(0.95)';
              }
            }}
            onMouseUp={(e) => {
              if (!disabled) {
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}
            aria-label={t('new_publication_page_ia_step_fourth_edit_art_button')}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 19V5M12 5L5 12M12 5L19 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      {/* <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          backgroundColor: '#FF8B001A',
          border: '1px solid #FF8B00',
          borderRadius: 50,
          padding: '10px 10px',
        }}
      >

        <WarningIcon color="#FF8B00" size={30} />

        <div
          style={{
            fontSize: 16,
            fontWeight: 400,
            fontFamily: 'Poppins',
            lineHeight:'auto'
          }}
        >
          <p style={{
            color:'#B36E00',
            margin:0,
            fontSize:14,
            fontWeight:400
          }}>
            <span style={{ fontWeight: 600, fontSize:14 }}>{t('new_publication_page_ia_step_fourth_badge_text_1')}</span>{' '}
            {t('new_publication_page_ia_step_fourth_badge_text_2')}
          </p>
          <p style={{
            margin:0,
            color:'#B36E00',
            fontSize:14,
            fontWeight:400
          }}>
            <span style={{ fontWeight: 600,  fontSize:14 }}>{t('new_publication_page_ia_step_fourth_badge_text_3')}</span>{' '}
            {t('new_publication_page_ia_step_fourth_badge_text_4')}
          </p>
        </div>
      </div> */}
    </div>
  )
}